// ** Initial State
const initialState = {
  project: {},
  loading: false,
  error: false,
};

const RequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PROJECT_DETAILS_INIT":
      return {
        ...state,
        loading: true,
        error: false,
      };
    case "PROJECT_DETAILS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        project: action.payload,
      };
    case "PROJECT_DETAILS_ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default RequestsReducer;
